// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const AlignBottomIcon = props => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M15 16a3 3 0 003-3V7a3 3 0 00-3-3H9a3 3 0 00-3 3v6a3 3 0 003 3h6zm1-3a1 1 0 01-1 1H9a1 1 0 01-1-1V7a1 1 0 011-1h6a1 1 0 011 1v6zm7 7a1 1 0 100-2H1a1 1 0 100 2h22z"/></svg>'} />;

AlignBottomIcon.displayName = 'AlignBottomIcon';

export default AlignBottomIcon;
